import { Component, OnInit, Input } from '@angular/core';
import { CommonService } from '../service/common.service';

  @Component({
    selector: 'status-list-ttt',
    templateUrl: './a-status-list.component.html',
})
export class AStatusListComponent implements OnInit {
    @Input() statuslist: any;
    
    constructor(
        private commonService: CommonService,
    ) { }

    ngOnInit() {
    }

}


// WEBPACK FOOTER //
// ./src/app/a0106-mail/a-status-list.component.ts